import { TIMER_START, TIMER_RUNNING, TIMER_STOP } from 'src/constants/constants';

const timerMiddleware = ({ dispatch, getState }) => {
  let timers = {};

  const setLock = (timerName, val) => (timerName.locked = val);
  const setStart = (timerName, fn) => {
    if (timerName.onStart) {
      timerName.onStart();
    }
  };
  const setComplete = (timerName, fn) => {
    if (timerName.onComplete) {
      timerName.onComplete();
    }

    if (timerName.onInitialComplete) {
      timerName.onInitialComplete();
      timerName.onInitialComplete = null;
    }
  };

  return next => action => {
    switch (action.type) {
      case TIMER_START: {
        let { name, onStart, onComplete, onInitialComplete } = action.payload;

        if (timers[name] === undefined) {
          timers[name] = { interval: null, locked: false };
        }

        timers[name].onComplete = onComplete;
        timers[name].onInitialComplete = onInitialComplete;
        timers[name].onStart = onStart;

        dispatch({ type: TIMER_RUNNING, payload: action.payload });

        break;
      }

      case TIMER_RUNNING: {
        let { name, action: timerAction, timeout, onStart, onComplete, onInitialComplete } = action.payload;

        const timerItem = timers[name];

        if (timerItem.locked === true || action === undefined) {
          return next(action);
        }

        clearInterval(timerItem.interval);
        timerAction(
          dispatch,
          getState,
          setLock.bind(null, timerItem),
          setStart.bind(null, timerItem, onStart),
          setComplete.bind(null, timerItem, onComplete, onInitialComplete),
        );

        timerItem.interval = setInterval(() => {
          dispatch({ type: TIMER_RUNNING, ...action });
        }, timeout);

        break;
      }

      case TIMER_STOP: {
        const { name } = action.payload;
        if (timers && timers[name] && timers[name].interval) {
          clearInterval(timers[name].interval);
        }
        const { [name]: omit, ...otherTimers } = timers;
        timers = otherTimers;
        break;
      }

      default: {
        return next(action);
      }
    }
  };
};

export default timerMiddleware;
